<template>
  <div>
    <v-container style="height: 400px;">
      <v-card class="mx-auto" max-width="600" elevation="10">
        <v-row class="fill-height" align-content="center" justify="center" >
          <v-col class="title text-center" cols="12">
            {{ $t('message.common.logoutSuccess') }}...
          </v-col>
           <v-col class="title text-center" cols="12">
            <v-btn class="primary mx-1" to="/login">{{ $t('message.layout.login') }}</v-btn>
            <v-btn class="info mx-1" to="/customer_login">{{ $t('message.layout.customerLogin') }}</v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
